import React from "react";

import { Building, AlertTriangle, CheckCircle } from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { useNetworksSummary } from "../hooks";

export const NetworksKpiCards: React.FC = () => {
  const { data: summaryData } = useNetworksSummary();


  const kpiData = [
    {
      title: "Total Networks",
      count: summaryData?.result?.totalNetworks || 0,
      icon: <Building className="h-6 w-6 text-blue-600" />,
    trendSummary:"Active network systems",
      tooltip:
        "Total count of all registered network systems in the utility, including active, inactive, and under maintenance networks.",
    },
    {
      title: "Networks Exceeding Design Capacity",
      count: summaryData?.result?.networksExceedingCapacity || 0,
      icon: <AlertTriangle className="h-6 w-6 text-red-600" />,
      trendSummary:"Require capacity upgrades",
      tooltip:
        "Number of networks where current operational capacity exceeds 95% of the original design capacity, indicating potential need for infrastructure upgrades.",
    },
    {
      title: "Total Leak Complaints (Last 30 Days)",
      count: summaryData?.result?.leakComplaints_30Days || 0,
      icon: <AlertTriangle className="h-6 w-6 text-orange-600" />,
      trendSummary:"Customer reported issues",
      tooltip:
        "Count of customer-reported leak complaints received in the last 30 days across all networks, used to identify potential system integrity issues.",
    },
    {
      title: "Average Network Age",
      count: summaryData?.result?.averageNetworkAge || 0,
      trendSummary:"Years in service",
      icon: <CheckCircle className="h-6 w-6 text-green-600" />,
      tooltip:
        "Average age of all networks calculated from installation date to current date, weighted by network size and importance.",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {kpiData.map((kpi, index) => (
        <QuickStatsCard
          key={index}
          title={kpi.title}
          count={kpi.count}
          trendSummary={kpi.trendSummary}
          icon={kpi.icon}
          tooltip={kpi.tooltip}
        />
      ))}
    </div>
  );
};